import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Button, Typography } from "@mui/material";

export default function PhotoCard(props) {
  const { story, setSelectedAlbumId } = props;
  const theme = useTheme();

  const hoverBoxMargin = 24;
  return (
    <Box
      sx={{
        display: "flex",
        position: "relative",
        margin: theme.spacing(5),
        mb: { xs: theme.spacing(0), md: theme.spacing(5) },
      }}
    >
      <Button
        width={"100%"}
        height={"100%"}
        onClick={() => {
          setSelectedAlbumId(story.id);
        }}
      >
        <img
          style={{
            width: "100%",
            // opacity: 0.9,
            "&:hover": {
              cursor: "pointer",
            },
          }}
          src={story.url}
          alt={story.title}
        ></img>
        <Box
          sx={{
            position: "absolute",
            opacity: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: `calc(100% - ${hoverBoxMargin * 2}px)`,
            height: `calc(100% - ${hoverBoxMargin * 2}px)`,
            backgroundColor: "rgba(237,231,228,1)",
            margin: `${hoverBoxMargin}px`,
            "&:hover": {
              cursor: "pointer",
              opacity: 0.5,
            },
          }}
        >
          <Typography
            variant="h6"
            paddingBottom={"12px"}
            textTransform="uppercase"
            fontWeight={530}
            letterSpacing={".2em"}
            color={"rgba(32, 32, 32, 1)"}
          >
            {story.title}
          </Typography>
          <Typography
            variant={{ xs: "body2", md: "subtitle2" }}
            paddingBottom={"12px"}
            textTransform="uppercase"
            fontWeight={530}
            fontStyle={"italic"}
            letterSpacing={".2em"}
            color={"rgba(32, 32, 32, 1)"}
          >
            {story.subtitle}
          </Typography>
        </Box>
      </Button>
    </Box>
  );
}
